import { ChangeDetectionStrategy, Component, input, output, TemplateRef, ViewChild } from '@angular/core';
import { Params, QueryParamsHandling } from '@angular/router';

export type MenuItemLink = {
  rawUrl?: URL | string;
  routerLink?: string | string[];
  queryParams?: Params;
  queryParamsHandling?: QueryParamsHandling;
  routerLinkActive?: string;
  fragment?: string | null;
};

@Component({
  selector: 'lib-menu-item',
  template: `
    <ng-template #template>
      <div (click)="clickAction.emit()">
        <ng-content />
      </div>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class MenuItemComponent {
  public menuItemLink = input<MenuItemLink>();
  public icon = input<string>();
  public clickAction = output<void>();
  @ViewChild('template')
  public template: TemplateRef<unknown>;
}
